const getEstablishmentYears = () => {
  return Array.from(
    { length: new Date().getFullYear() - 499 },
    (_, i) => i + 500,
  ).reverse();
};

export default getEstablishmentYears;
